import React from "react";
import {observer} from "mobx-react";
import GeneralDialog from "./GeneralDialog";
import {useStores} from "../../Hooks";
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
const ReplaceMediaModal = observer(() => {
    const {modalStore, generalStore} = useStores();
    const file = generalStore.oldMediaFileToBeReplaced;

    const handleConfirmReplace = () => {
        modalStore.isUploadModalOpen = true;
    }


    return (
        <GeneralDialog
            openControl='isReplaceMediaModalOpen'
            className='replace-dialog-media'
            onEnter={null}
            bodyClassName='replace-media'
            title={<div><ErrorOutlineIcon fontSize='large' className='replace-media-icon' /> <div>{generalStore.translate('Attention')}</div></div>}
            body={
                <div style={{color: "#36415D", display: "flex", justifyContent: "center", alignItems:"center", flexDirection: "column"}}>
                    <div className="dialog-description">
                        {generalStore.translate('ThisMediaIsCurrentlyUsedIn')+' '+file?.procedures?.length+' '+generalStore.translate('procedures:', false)}
                    </div>
                    <div style={{display: "flex", flexDirection:"column", justifyContent: "flex-start"}}>
                        {file?.procedures?.map(procedure=> <div style={{marginLeft: "-200px"}}>{`• ${procedure.ProcedureName}`}</div>)}
                    </div>
                    <div className="dialog-description media-replace">
                        {generalStore.translate('DoYouWantToReplaceItInAllProcedures?')}
                    </div></div>
            }
            isConfirmDisabled={false}
            onConfirm={handleConfirmReplace}
            preserveDataOnClose
            confirmText={generalStore.translate('Replace')}
            headerClassName={modalStore.modalData.headerClassName}
            buttonsClassName='center-buttons-media'
        />
    );
});


export default ReplaceMediaModal;
